export default "<p>bulk-application works!</p>\r\n";